import { BaseParameterDto } from './base-parameter-dto';

export class ActionAccessListParameterDto extends BaseParameterDto {
    communityId: number;
    customerId: string;
    corporateId: number;

    getQueryString(): string {
        let url = `?clearCache=${this.clearCache}`;

        if (this.communityId) {
            url = url + `&communityId=${this.communityId}`;
        }
        if (this.customerId) {
            url = url + `&customerId=${this.customerId}`;
        }
        if (this.corporateId) {
            url = url + `&corporateId=${this.corporateId}`;
        }

        return url;
    }
}
